import "firebase/compat/app-check";
import firebase from "firebase/compat/app";
import Constants from "expo-constants";

const appEnv = Constants.expoConfig?.extra?.appEnv;

const firebaseConfig = (() => {
    switch (appEnv) {
        case "local":
            return {
                apiKey: "AIzaSyBjD3vNQOnnSWEK7Oj-baRhe-spjluFcGI",
                authDomain: "acquired-router-361310.firebaseapp.com",
                databaseURL:
                    "https://acquired-router-361310-default-rtdb.europe-west1.firebasedatabase.app",
                projectId: "acquired-router-361310",
                storageBucket: "acquired-router-361310.appspot.com",
                messagingSenderId: "105780495145",
                appId: "1:105780495145:web:54a04e00e3de78436c2d38",
                measurementId: "G-XJCVXJWWN6",
            };
        case "dev":
            return {
                apiKey: "AIzaSyAkUR2tAefy-NIqnfWUEkxu6QPih8Wg1ig",
                authDomain: "lift-dev-403307.firebaseapp.com",
                projectId: "lift-dev-403307",
                storageBucket: "lift-dev-403307.appspot.com",
                messagingSenderId: "873738090827",
                appId: "1:873738090827:web:898a49c2948613ec6050ce",
                measurementId: "G-SVHWM5E7DG",

                // reCAPTCHA Site key
                reCaptchaEntrepriseSiteKey: "6LcTgnopAAAAAG8YJX0NC-JzVCVt0AdPYLshx5VZ",
            };
        case "demo":
            return {
                apiKey: "AIzaSyD_6EjtleD0eMCawNgZtSmuB4mxZam3L6k",
                authDomain: "lift-demo-401107.firebaseapp.com",
                projectId: "lift-demo-401107",
                storageBucket: "lift-demo-401107.appspot.com",
                messagingSenderId: "791191052785",
                appId: "1:791191052785:web:4ed52c3ace7b54fd80e450",
                measurementId: "G-CCWEJ6VEBG",
            };
        case "production":
            return {
                apiKey: "AIzaSyAvArnSw9MJVsRtBNy2-y49zkAYfY5YEgU",
                authDomain: "lift-production-404409.firebaseapp.com",
                projectId: "lift-production-404409",
                storageBucket: "lift-production-404409.appspot.com",
                messagingSenderId: "110331645354",
                appId: "1:110331645354:web:7fc5003121e56fcfea6fd3",
                measurementId: "G-L6W0KMKMF7",
            };
        default:
            break;
    }
})();

if (firebaseConfig) {
    const app = firebase.initializeApp(firebaseConfig);

    if (firebaseConfig.reCaptchaEntrepriseSiteKey) {
        const appCheck = firebase.appCheck(app);

        appCheck.activate(
            new firebase.appCheck.ReCaptchaEnterpriseProvider(
                firebaseConfig.reCaptchaEntrepriseSiteKey,
            ),
            true,
        );
    }
}

export default firebase;
